import { BasicLogProgressTile } from './Basic';
import { CompletionLogProgressTile } from './Completion';
import { TargetLogProgressTile } from './Target';

export const LogProgressTile = {
  Basic: BasicLogProgressTile,
  Target: TargetLogProgressTile,
  Completion: CompletionLogProgressTile,
};
